import { Card, Button, Space, Tag, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useGetVendors } from "~/services/vendor";

export const VendorManagement = () => {
  const { data: vendors, isLoading } = useGetVendors();
  return (
    <Spin spinning={isLoading}>
      <Card title="Vendor Management">
        {vendors && vendors.meta.totalItems > 0 ? (
          vendors.items.map((vendor) => (
            <Card className="mb-3">
              <div className="flex justify-between items-center">
                <span className="font-medium">{vendor.name}</span>
                <Tag color="green">Active</Tag>
              </div>
              <div className="text-sm mt-1">
                <Space>
                  <span>Last order: Jan 15, 2023</span>
                  <span>•</span>
                  <span>0 item</span>
                </Space>
                <div className="mt-2">
                  <a href="#" className="text-blue-600">
                    View catalog ({vendor.supplies?.length} item
                    {(vendor.supplies?.length ?? 0) > 0 ? "s" : ""})
                  </a>
                </div>
              </div>
            </Card>
          ))
        ) : (
          <div className="text-center text-gray-500">No vendors found.</div>
        )}
        <Space>
          <Button>View All Vendors</Button>
          <Button icon={<PlusOutlined />}>Add Vendor</Button>
        </Space>
      </Card>
    </Spin>
  );
};
